import React, { useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Ticker({
  feed,
  title,
  position='bottom',
  backgroundColor='rgba(255,255,255,0)',
}) {
  const reducer = (currentIndex) => (currentIndex >= feed.length - 1 ? 0 : currentIndex + 1);

  const [index, setIndex] = useReducer(reducer, 0);
  const [isPaused, setIsPaused] = useState(
    () => window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );

  useEffect(() => {
    if (isPaused) return;
    const intervalId = setInterval(setIndex, 5000);
    return () => clearInterval(intervalId);
  }, [isPaused]);

  // const link = ({
  //   href,
  //   children,
  // }) => (
  //     <a
  //       href={href}
  //       target="_blank"
  //       rel="noopener noreferrer"
  //     >
  //       {children}
  //     </a>
  //   );
  if (feed.length) {
    return (
      <div
        className="news-feed"
        role="region"
        aria-label="News feed"
        style={{
          top: (position === 'top') ? 0 : undefined,
          backgroundColor,
        }}
      >
        <div
          className="news-feed-inner"
          style={{ fontSize: '14px' }}
        >
          <strong className="news-feed-label">
            <FontAwesomeIcon icon={['fal', 'comment-alt-lines']} aria-hidden="true" />
            {title}
          </strong>
          <div className="news-feed-player">
            <button
              type="button"
              className="news-feed-toggle"
              onClick={() => setIsPaused(p => !p)}
              aria-label={isPaused ? 'Play news feed' : 'Pause news feed'}
              aria-pressed={isPaused}
            >
              <FontAwesomeIcon icon={['fal', isPaused ? 'play-circle' : 'pause-circle']} aria-hidden="true" />
            </button>
            <span role="status" className="sr-only">
              {isPaused ? 'News feed paused' : 'News feed playing'}
            </span>
            <div aria-live="polite" aria-atomic="true" className="news-feed-news-text">
              <ReactMarkdown>{feed[index]}</ReactMarkdown>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return '';
}

Ticker.propTypes = {
  feed: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string.isRequired,
  position: PropTypes.string,
  backgroundColor: PropTypes.string,
};

